import { Star } from "@phosphor-icons/react";

export default function Stars({ count = 5, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${count} de 5 estrelas`}>
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} weight="fill" className="h-4 w-4 text-brand-red" />
      ))}
    </div>
  );
}
